import { PostData } from '../types';
export const tallFeedImage = (data: PostData) =>
  data.publishingMethod === 'DIRECT' &&
  data.media &&
  data.media.width < data.media.height &&
  data.media.width / data.media.height < 4 / 5;
